import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import URL from '../constants/url';

const NAV_ITEMS = [
  { to: URL.ABOUT, label: '회사소개' },
  { to: URL.PRODUCTS, label: '제품소개' },
  { to: URL.CONTACT, label: '오시는 길' },
];

function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openMobileMenu = () => {
    setMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.body.classList.add('is-mobile-menu-open');
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.classList.remove('is-mobile-menu-open');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mobileMenuOpen]);

  return (
    <header className={`header ${mobileMenuOpen ? 'isMenuOpen' : ''}`}>
      <div className="inner">
        <div className="inner_layout">
          <div className="inner_logo_con">
            <Link to={URL.MAIN} className="inner_logo_link" aria-label="이케이시스 홈으로 이동">
              <img
                src="/images/eksys_logo.png"
                className="inner_logo_img"
                alt="eksys 이케이시스"
              />
            </Link>
          </div>

          <nav className="gnb_con" aria-label="주요 메뉴">
            <div className="global_navigation_bar">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `gnb_link ${isActive ? 'active' : ''}`
                  }
                >
                  <span className="gnb_item">{item.label}</span>
                </NavLink>
              ))}
            </div>
          </nav>

          <div className="right_a">
            <button
              type="button"
              className={`mobile_menu_button ${mobileMenuOpen ? 'isOpen' : ''}`}
              onClick={toggleMobileMenu}
              aria-label={mobileMenuOpen ? '전체메뉴 닫기' : '전체메뉴 열기'}
              aria-expanded={mobileMenuOpen}
              aria-controls="mobileMenu"
            >
              <span className="mobile_menu_button_icon" aria-hidden="true">
                <span />
                <span />
                <span />
              </span>
            </button>
          </div>
        </div>
      </div>

      <div
        id="mobileMenu"
        className={`mobile_menu ${mobileMenuOpen ? 'isOpen' : ''}`}
        onClick={closeMobileMenu}
      >
        <nav
          className="mobile_menu_panel"
          aria-label="모바일 전체 메뉴"
          onClick={(e) => e.stopPropagation()}
        >
          {/* <div className="mobile_menu_head">
            <Link
              to={URL.MAIN}
              className="mobile_menu_logo"
              aria-label="이케이시스 홈으로 이동"
            >
              <img src="/images/eksys_logo.png" alt="eksys 이케이시스" />
            </Link>

            <button
              type="button"
              className="mobile_menu_close"
              onClick={closeMobileMenu}
              aria-label="전체메뉴 닫기"
            >
              닫기
            </button>
          </div> */}

          <div className="mobile_menu_intro">
            <Link
              to={URL.MAIN}
              className="mobile_menu_logo"
              aria-label="이케이시스 홈으로 이동"
            >
              <img src="/images/eksys_logo.png" alt="eksys 이케이시스" />
            </Link>
            <span>이케이시스의 주요 메뉴를 확인하세요.</span>
          </div>

          <div className="mobile_menu_links">
            {NAV_ITEMS.map((item, index) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `mobile_menu_link ${isActive ? 'active' : ''}`
                }
                onClick={closeMobileMenu}
                style={{ '--delay': `${index * 70}ms` }}
              >
                {/* <span className="mobile_menu_index">
                  {String(index + 1).padStart(2, '0')}
                </span> */}
                <span className="mobile_menu_label">{item.label}</span>
              </NavLink>
            ))}
          </div>

          <div className="mobile_menu_footer">
            <strong>eKsys</strong>
            <span>Creative IT Consulting Partner</span>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;